
export default [
  { "id": 1, "name": { "en": "Manager" }},
  { "id": 2, "name": { "en": "Entrepreneur" }},
  { "id": 3, "name": { "en": "Researcher" }},
]